import { type FC, useEffect, useState } from 'react';

type LoadingDotsProps = {
  isLoading: boolean;
};

export const LoadingDots: FC<LoadingDotsProps> = ({ isLoading }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (!isLoading) {
      setDots('');
      return;
    }

    let dotCount = 0;
    const interval = setInterval(() => {
      dotCount = (dotCount + 1) % 4;
      setDots('.'.repeat(dotCount));
    }, 500);

    return () => clearInterval(interval);
  }, [isLoading]);

  return dots;
};

LoadingDots.displayName = 'UI/LoadingDots';
